export default class FileManagerStyles {
    static getStyle(theme = {}) {
        return ({
            dragzone: {
                cursor: 'pointer',
                border: `1px solid ${theme.palette.border.alto}`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '5px 10px',
                transition: 'border-color .3s',
                height: '35px',
                color: theme.palette.text.white,
                backgroundColor: theme.palette.success.main,
                '& > svg': {
                    fill: theme.palette.text.white,
                    width: '20px',
                    height: '20px',
                    marginLeft: '5px',
                },
            },
            customDragzone: {
                cursor: 'pointer',
                border: `2px dashed ${theme.palette.border.violetMajesty}`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '5px 5px',
                transition: 'border-color .3s',
                backgroundColor: theme.palette.background.placeboPurple,
                borderRadius: '5px',
                '& > svg': {
                    fill: theme.palette.border.ghost,
                    width: '20px',
                    height: '20px',
                },
            },
            dropzoneContent: {
                fontSize: '17px',
                display: 'flex',
                columnGap: '10px',
                alignItems: 'center',
                '& > svg': {
                    fill: theme.palette.background.olympicBlue,
                    width: '60px',
                    height: '60px',
                },
            },
            tableContainer: {
                marginTop: '3px',
                height: '100%',
            },
            tableHeader: {
                textAlign: 'left',
                color: theme.palette.text.waterloo,
                borderRight: `1px solid ${theme.palette.border.ghost}`,
                height: '100%',
                alignItems: 'center',
            },
            text: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            deleteButton: {
                minWidth: '32px',
                '& span.MuiButton-startIcon': {
                    margin: 0,
                },
            },
            loader: {
                position: 'absolute',
                left: '0',
                top: '0',
                zIndex: '999',
                backgroundColor: theme.palette.background.white,
                width: '100%',
                height: '98%',
                opacity: '0.5',
            },
            download: {
                padding: 0,
                minWidth: 'initial',
                marginRight: '10px',
                '& > span > span': {
                    margin: 0,
                    '& > svg': {
                        fontSize: '25px !important',
                    },
                },
            },
            nameWrapper: {
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                '& > div:nth-child(1)': {
                    width: '90%',
                    cursor: 'pointer',
                    color: theme.palette.secondary.main,
                    '& > div.MuiOutlinedInput-root': {
                        marginRight: '10px',
                        '& > input': {
                            height: '13px !important',
                        },
                    },
                },
                '& > div:nth-child(2)': {
                    width: '10%',
                    '& > button': {
                        padding: '5px',
                        minWidth: 'initial',
                        '& > span > span': {
                            margin: 0,
                            '& > svg': {
                                fontSize: '16px !important',
                            },
                        },
                    },
                },
            },
            textFieldSmall: {
                '& input': {
                    padding: 7,
                },
            },
            tableWrapper: {
                backgroundColor: theme.palette.background.white,
            },
        });
    }
}
